import * as React from "react";
import * as $ from "jquery";
import { Guid } from "../Utils/Guid";
import { BindOnClickOutside, UnbindOnClickOutside } from "../Utils/OnClickOutside";
import { Portal } from "./Components/Portal";
import { Content } from "./Resources/Content";

export interface IDivState {}

export interface IDivProps extends React.HTMLProps<Div> {
    isLoading?: boolean;

    isBlocking?: boolean;

    isInline?: boolean;

    onClickOutside?: (event: any) => void;
}

/**
 * Pepa chtel, aby se to jmenoval LoadingWrapper. Nesouhlasim.
 */
export class Div extends React.Component<IDivProps, IDivState> {
    private _divRef: HTMLDivElement;
    private _isMounted: boolean;
    private _clickEventId: string = Guid.getNext();

    constructor(props: IDivProps) {
        super(props);
        this.state = {};
    }

    public componentDidMount(): void {
        this._isMounted = true;

        if (this.props.onClickOutside) {
            BindOnClickOutside(
                $(this._divRef),
                this._clickEventId,
                (event: any) => this._isMounted && this.props.onClickOutside(event)
            );
        }
    }

    public componentWillUnmount(): void {
        this._isMounted = false;
        if (this.props.onClickOutside) {
            UnbindOnClickOutside(this._clickEventId);
        }
    }

    public render(): JSX.Element {
        const { isBlocking, isLoading, onClickOutside, ...rest } = this.props;
        const divProps: any = $.extend({}, rest);
        divProps.ref = (div: HTMLDivElement) => (this._divRef = div);
        const targetLoadingContainer = this.getTargetLoadingContainer(this.props.isBlocking);

        if (this.props.isInline) {
            divProps.style = { display: "inline" } as React.CSSProperties;
        }

        return (
            <div {...divProps}>
                <Portal container={targetLoadingContainer}>
                    {this.props.isLoading && this.getLoadingIndicator(this.props.isBlocking)}
                </Portal>

                {this.props.children}
            </div>
        );
    }

    private getTargetLoadingContainer(isBlocking: boolean): HTMLElement {
        return isBlocking
            ? document.getElementById("loading-div-container-blocking")
            : document.getElementById("loading-div-container-non-blocking");
    }

    private getLoadingIndicator(isBlocking: boolean): JSX.Element {
        return isBlocking ? this.getBlockingIndicator() : this.getNonBlockingIndicator();
    }

    private getBlockingIndicator(): JSX.Element {
        return (
            <div className="preloader-blocking" aria-live="polite">
                <span className="sr-only">{Content.Loading}</span>
            </div>
        );
    }

    private getNonBlockingIndicator(): JSX.Element {
        return (
            <div className="preloader-non-blocking" aria-live="polite">
                <div className="bar" />
                <span className="sr-only">{Content.Loading}</span>
            </div>
        );
    }
}
